import React, {
	Component,
} from 'react';
import {
	connect,
} from 'react-redux';
import './SchedulePage.css';
import Tabbar from '../../Components/Tabbar/Tabbar';
import {
	getAll,
	getScheduledEvents,
	add,
	del,
	edit,
} from '../../Store/Actions/RestActions';
import { scheduleDelete, scheduleSave, scheduleEdit } from '../../Store/Actions/SchedulerActions';
import PageFilter from '../../Components/Pages/PageFilter';
import SchedulePageComponent from '../../Components/Pages/SchedulePageComponent';
import ReservationTypeModal from '../../Components/Modals/ReservationTypesModal';

class SchedulePage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			// modalIsopen: false,
			name: ''
		};
		this.form = true;
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		this.setState({
			[name]: value,
		});
	}


	handleSubmit(name) {
		// event.preventDefault();
		this.props.addReservationType(name);
	}

	componentDidMount() {
		this.props.buildingsFetch();
		this.props.roomTypeFetch();
		this.props.assetsFetch();
		this.props.floorsFetch();
		this.props.roomsFetch();
		this.props.reservationTypeFetch();
		this.props.usersFetch();
		this.props.scheduleFetch(Date.now());

	}

	render() {
		let isAdmin = JSON.parse(localStorage.getItem("isAdmin")) || false;
		let isSuperman = JSON.parse(localStorage.getItem("isSuperman")) || false;
		return (
			< div className="container" >
				<Tabbar setActiveTab="schedule" />
				<div className="contentBox tabbed-content-box no-padding" id="contentBoxHeight">
					<PageFilter {...this.props}>
						<SchedulePageComponent />
					</PageFilter>
					{(isAdmin || isSuperman) ?

						<ReservationTypeModal handleSubmit={this.props.addReservationType} handleEdit={this.props.editReservationType} {...this.props} />
						: ""
					}
				</div>

			</div >
		);
	}
}

SchedulePage.displayName = 'schedule';

const mapStateToProps = state => ({
	schedule: state.schedulePage,
	roomTypes: state.roomTypes.data,
	assets: state.assets.data,
	buildings: state.buildings.data,
	floors: state.floors.data,
	rooms: state.rooms.data,
	accountId: state.auth.accountId,
	events: state.events.data,
	reservationTypes: state.reservationTypes.data,
	isAdmin: state.auth.isAdmin,
	isSuperman: state.auth.isSuperman,
	isEventCreator: state.auth.isEventCreator,
	userId: state.auth.userId,
	filterData: state.rooms.data,
	roomId: state.roomId,
	users: state.users.data,
	eventLoading: state.events.isLoading,
	roomsLoading: state.events.isLoading,
	usersLoading: state.users.isLoading,
});

const mapDispatchtoProps = dispatch => ({
	scheduleFetch: (date) => dispatch(getScheduledEvents(date)),
	eventSaved: (event) => dispatch(scheduleSave(event)),
	eventUpdated: (event) => dispatch(scheduleEdit(event)),
	eventDeleted: (event) => dispatch(scheduleDelete(event)),
	buildingsFetch: () => dispatch(getAll('buildings', {})),
	floorsFetch: () => dispatch(getAll('floors', {})),
	roomTypeFetch: () => dispatch(getAll('roomtypes', {})),
	roomsFetch: () => dispatch(getAll('rooms', {})),
	resourceTypeFetch: () => dispatch(getAll('assetdetailtypes', {})),
	assetsFetch: () => dispatch(getAll('assets', {})),
	reservationTypeFetch: () => dispatch(getAll('reservationtypes', {})),
	addReservationType: (data) => dispatch(add('reservationtypes', data)),
	editReservationType: (data) => dispatch(edit('reservationtypes', data, data.id)),
	deleteReservationType: (id) => dispatch(del('reservationTypes', "", id)),
	usersFetch: () => dispatch(getAll('onlyActiveUsers', {}))
});
export default connect(mapStateToProps, mapDispatchtoProps)(SchedulePage);



// WEBPACK FOOTER //
// ./src/Pages/SchedulePage/SchedulePage.js